import { rootApi } from '../rootApi';
import { AdminOrganization } from './admin.types';
import { AccountProfile } from '../account/account.types';
import { PageOptions, PaginatedResponse } from '../api.types';

const adminService = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getAllOrganizations: build.query<
      PaginatedResponse<AdminOrganization>,
      PageOptions & { search_query?: string }
    >({
      query: (params) => ({
        url: '/system/tenant/organizations',
        params,
      }),
    }),

    getAllAccounts: build.query<
      PaginatedResponse<AccountProfile>,
      PageOptions & { search_query?: string }
    >({
      query: (params) => ({
        url: '/system/tenant/accounts',
        params,
      }),
    }),

    getAccountsByOrganization: build.query<
      PaginatedResponse<AccountProfile>,
      { params: PageOptions; orgId: string }
    >({
      query: ({ params, orgId }) => ({
        url: `/system/tenant/organizations/${orgId}/accounts`,
        params,
      }),
    }),
  }),
});

export const {
  useGetAllOrganizationsQuery,
  useGetAllAccountsQuery,
  useGetAccountsByOrganizationQuery,
} = adminService;
